import "../HomePageList/HomePageList.scss";
import { useNavigate } from "react-router-dom";
import NoProducts from "../../../../Shared/NoProducts/NoProducts";
import {
  API_RESPONSE,
  COMMON_CONSTANTS,
  I18_TRANSLATION_COMMON,
  ROUTES,
  TOASTER_CONFIGS,
} from "../../../../Utilities/Constants/Constants";
import { axiosInstance } from "../../../../Services/Interceptor/Interceptor";
import API_END_POINTS from "../../../../Utilities/Constants/ApiEndpoints";
import { useEffect, useState } from "react";
import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  Tooltip,
  Pagination,
} from "@mui/material";
import edit from "../../../../../Assets/global/edit.svg";
import FileViewerDialog from "../../../../Shared/FileViewerDialog/FileViewerDialog";
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import { useTranslation } from "react-i18next";
import HttpsIcon from "@mui/icons-material/Https";
import LockOpenTwoToneIcon from "@mui/icons-material/LockOpenTwoTone";
import { toast } from "react-toastify";
import BulkUploadDialog from "../../../../Shared/BulkUploadDialog/BulkUploadDialog";
import RadioBtnDialog from "../../../../Shared/RadioBtnDialog/RadioBtnDialog";
import ThemeParkPromotionDialog from "../../../../Shared/ThemeParkPromoteDialog/ThemeParkPromoteDialog";


const ThemeParkList = () => {
  const { t } = useTranslation(I18_TRANSLATION_COMMON.COMMON);
  const navigate = useNavigate();
  const [homeContentsList, setHomeContentsList] = useState<any>([]);
  const [hasProducts, setHasProducts] = useState(true);
  const [fileViewerOpen, setFileViewerOpen] = useState(false);
  const [viewerFile, setViewerFile] = useState("");
  const [page, setPage] = useState(1);
  const [totalPage, setTotalCount] = useState(0);
  const [rowPerPage, setRowPerPage] = useState(10);
  const [isBulkUploadDialogOpen, setisBulkUploadDialogOpen] = useState(false);
  const [isRadioBtnDialogOpen, setIsRadioBtnDialogOpen] = useState(false);
  const [isThemeParkPromoteDialogOpen, setIsThemeParkPromoteDialogOpen] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [id, currentId] = useState();

  const closeBulkUploadDialog = () => {
    setisBulkUploadDialogOpen(false);
  };

  const closeRadioBtnDialog = () => {
    setIsRadioBtnDialogOpen(false);
  };

  const openBulkUploadDialog = () => {
    setisBulkUploadDialogOpen(true);
  };
  
  const openRadioBtnDialog = () => {
    setIsRadioBtnDialogOpen(true)
  }

  const openThemeParkPromoteDialog = () => {
    setIsThemeParkPromoteDialogOpen(true)
  }

  const handleClose = () => {
    setIsThemeParkPromoteDialogOpen(false)
  }

  useEffect(() => {
    getContentsList();
  }, [page,rowPerPage]);


    // track admin-record 
useEffect(() => {
  console.log("pathh", window.location?.pathname)
  const pathName = window.location?.pathname;
  const payload = {
    record_area: pathName.slice(1)
  }
  axiosInstance.post(`${API_END_POINTS?.RECORD_AREA}`, payload).then((response: any) => {
    console.log(response)
  }).catch(() => {
  })
}, [])

    /**Handle row per page change */
    const onRowChange = (event: any) => {
      setPage(COMMON_CONSTANTS.ONE)
      setRowPerPage(parseInt(event.target.value));
    };
  
    const handleChangePage = (event: React.ChangeEvent<any>, newPage: number) => {
      setPage(newPage);
    };
  

  /* Getting contents list,API call */
  const getContentsList = () => {
    axiosInstance.get(API_END_POINTS.ADD_HOMEPAGE_SECOND +
      "?page=" +
      page +
      "&limit=" +
      rowPerPage).then((response) => {
      if (response.data.status === API_RESPONSE.TRUE) {
        setHomeContentsList([...response.data.result.data]);
        setTotalCount(response.data.result.total_page);
        response.data.result.data.length > 0
          ? setHasProducts(API_RESPONSE.TRUE)
          : setHasProducts(API_RESPONSE.FALSE);
      }
    });
  };


  const activateContent = (id:any)=>{
    axiosInstance.put(API_END_POINTS.ACTIVATE_HOMEPAGE_CONTENT + `?id=${id}`,{}).then((response) => {
      if (response.data.status === API_RESPONSE.TRUE) {
        getContentsList();
        toast.success(response.data.message, TOASTER_CONFIGS);
      }
    })
  }

  /**Handle file viewer dialog open */
  const onFilerViewerDialogOpen = (url: any) => {
    setViewerFile(url);
    setFileViewerOpen(true);
  };

  /**Handle file viewer dialog close */
  const onFilerViewerDialogClose = () => {
    setFileViewerOpen(false);
    setViewerFile("");
  };

  return (
    <div className="home-content-wrapper">
      <div className="row create-btn-tp-wrap">

        <button
          className="col-md-12 btn btn-secondary m-1"
          onClick={openRadioBtnDialog}
        >
         Trending Choose 
        </button>
        <RadioBtnDialog 
        onCloseDialog={closeRadioBtnDialog}
        isOpen={isRadioBtnDialogOpen}
        uploadType={"staticupload"}
        />
        
        <button
          className="col-md-12 btn btn-secondary m-1"
          onClick={ openThemeParkPromoteDialog }
        >
          ThemePark Promote Order
        </button>
        
        <ThemeParkPromotionDialog 
        onCloseDialog={handleClose}
        isOpen={isThemeParkPromoteDialogOpen}
        uploadType={"staticupload"}
        />

        <button
          className="col-md-12 btn btn-secondary m-1"
          onClick={() => {
            navigate(`${ROUTES.MANAGE_THEMEPARK_CONTENTS}`);
          }}
        >
          Manage ThemePark Content
        </button>

      </div>

      
      <FileViewerDialog
        open={fileViewerOpen}
        handleClose={onFilerViewerDialogClose}
        viewerFile={viewerFile}
      ></FileViewerDialog>
      
    </div>
  );
};

export default ThemeParkList;
